export default __webpack_public_path__ + "static/media/stvincentdepaul.8f9265ca.jpg";